'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Autocomplete = exports.styles = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

var _reactAutocomplete = require('../../react-autocomplete');

var _reactAutocomplete2 = _interopRequireDefault(_reactAutocomplete);

var _Paper = require('material-ui/Paper');

var _Paper2 = _interopRequireDefault(_Paper);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Clear = require('material-ui-icons/Clear');

var _Clear2 = _interopRequireDefault(_Clear);

var _RemoveRedEye = require('material-ui-icons/RemoveRedEye');

var _RemoveRedEye2 = _interopRequireDefault(_RemoveRedEye);

var _AddCircleOutline = require('material-ui-icons/AddCircleOutline');

var _AddCircleOutline2 = _interopRequireDefault(_AddCircleOutline);

var _Save = require('material-ui-icons/Save');

var _Save2 = _interopRequireDefault(_Save);

var _List = require('material-ui/List');

var _List2 = _interopRequireDefault(_List);

var _styles = require('material-ui/styles/');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = exports.styles = {
  root: {
    // border: "1px solid red",
    width: "100%"
  },
  menuWrapper: {
    position: "relative"
  },
  menuPaper: {
    maxHeight: 300,
    width: "100%",
    overflow: "auto",
    padding: 5,
    position: "absolute",
    zIndex: 100,
    top: 0
  },
  menuList: {
    padding: 0
  },
  menuListItem: {
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 5,
    paddingRight: 5,
    cursor: "pointer",
    fontSize: "0.9rem",
    "&:first-child": {// fontSize: "1.1rem",
    },
    "&:hover": {
      backgroundColor: "#eee"
    },
    "&.active": {
      backgroundColor: "#ddd"
    }
  },
  menuListItemText: {},
  actionButton: {
    height: 30,
    width: 30
  },
  accent: {
    color: "red"
  }
};
var Autocomplete = exports.Autocomplete = (_temp2 = _class = function (_Component) {
  _inherits(Autocomplete, _Component);

  function Autocomplete() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Autocomplete);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Autocomplete, [{
    key: 'render',
    value: function render() {
      var Grid = this.context.Grid;

      var _props = this.props,
          classes = _props.classes,
          wrapperProps = _props.wrapperProps,
          items = _props.items,
          value = _props.value,
          fullWidth = _props.fullWidth,
          style = _props.style,
          getItemText = _props.getItemText,
          onDelete = _props.onDelete,
          viewHandler = _props.viewHandler,
          viewElement = _props.viewElement,
          saveHandler = _props.saveHandler,
          addHandler = _props.addHandler,
          renderInput = _props.renderInput,
          other = _objectWithoutProperties(_props, ['classes', 'wrapperProps', 'items', 'value', 'fullWidth', 'style', 'getItemText', 'onDelete', 'viewHandler', 'viewElement', 'saveHandler', 'addHandler', 'renderInput']); // let items = [
      //   { value: 'AL', label: 'Alabama' },
      //   { value: 'AK', label: 'Alaska' },
      //   { value: 'AZ', label: 'Arizona' },
      //   { value: 'AR', label: 'Arkansas' },
      //   { value: 'CA', label: 'California' },
      //   { value: 'CO', label: 'Colorado' },
      //   { value: 'CT', label: 'Connecticut' },
      // ];


      var addButton = void 0;
      var viewButton = void 0;
      var saveButton = void 0;

      if ((viewHandler || viewElement) && value) {
        // if(!viewElement){
        //   viewElement = IconButton;
        // }
        viewButton = _react2.default.createElement(Grid, {
          item: true
        }, viewElement ? viewElement : _react2.default.createElement(_IconButton2.default, {
          onClick: viewHandler,
          className: classes.actionButton
        }, _react2.default.createElement(_RemoveRedEye2.default, null)));
      }

      if (addHandler) {
        // if(!viewElement){
        //   viewElement = IconButton;
        // }
        addButton = _react2.default.createElement(Grid, {
          item: true
        }, _react2.default.createElement(_IconButton2.default, {
          onClick: addHandler,
          className: [classes.actionButton].join(" ")
        }, _react2.default.createElement(_AddCircleOutline2.default, null)));
      }

      if (saveHandler) {
        // if(!viewElement){
        //   viewElement = IconButton;
        // }
        saveButton = _react2.default.createElement(Grid, {
          item: true
        }, _react2.default.createElement(_IconButton2.default, {
          onClick: saveHandler,
          className: [classes.actionButton, classes.accent].join(" ")
        }, _react2.default.createElement(_Save2.default, null)));
      }

      return _react2.default.createElement(Grid, {
        container: true,
        spacing: 0
      }, _react2.default.createElement(_reactAutocomplete2.default // debug={true}
      , _extends({
        renderInput: renderInput ? renderInput : function (props) {
          var ref = props.ref,
              inputProps = props.inputProps,
              other = _objectWithoutProperties(props, ['ref', 'inputProps']);

          return _react2.default.createElement(Grid, {
            container: true,
            spacing: 0,
            alignItems: 'center'
          }, _react2.default.createElement(Grid, {
            item: true,
            xs: true
          }, _react2.default.createElement(_TextField2.default, _extends({
            fullWidth: fullWidth,
            inputProps: _extends({
              ref: ref
            }, inputProps)
          }, props))), addButton, viewButton, onDelete && value ? _react2.default.createElement(Grid, {
            item: true
          }, _react2.default.createElement(_IconButton2.default, {
            onClick: onDelete,
            className: classes.actionButton
          }, _react2.default.createElement(_Clear2.default, null))) : null, saveButton);
        },
        renderDebug: function renderDebug(debugStates) {
          return _react2.default.createElement(Grid, {
            item: true,
            xs: 12 // style={{
            //   maxHeight: "70%",
            // }}

          }, _react2.default.createElement('pre', {
            style: {
              // marginLeft: 300 
              // position: "absolute",
              // top: "100%",
              maxHeight: "100%",
              overflow: "auto"
            }
          }, JSON.stringify(debugStates.slice(Math.max(0, debugStates.length - 5), debugStates.length), null, 2)));
        },
        wrapperProps: _extends({}, wrapperProps, {
          className: [classes.root, wrapperProps && wrapperProps.className || ""].join(" ")
        }) // value={this.state.value}
        ,
        value: value || "" // inputProps={{ id: 'states-autocomplete' }}
        // wrapperStyle={{ position: 'relative', display: 'inline-block' }}
        ,
        wrapperStyle: style,
        items: items,
        getItemValue: function getItemValue(item) {
          return item.label;
        } // shouldItemRender={matchStateToTerm}
        // sortItems={sortStates}
        // onChange={(event, value) => this.setState({ value })}
        // onSelect={value => this.setState({ value })}
        ,
        renderMenu: function renderMenu(children) {
          if (!children || !children.length) {
            return _react2.default.createElement('div', null);
          }

          return _react2.default.createElement(Grid, _defineProperty({
            className: 'menu',
            item: true,
            xs: 12
          }, 'className', classes.menuWrapper), _react2.default.createElement(_Paper2.default, {
            className: classes.menuPaper
          }, _react2.default.createElement(_List2.default, {
            className: classes.menuList
          }, children)));
        },
        renderItem: function renderItem(item, isHighlighted, style) {
          var text = getItemText(item);
          var id = item.id;
          return _react2.default.createElement(_List.ListItem, {
            id: id,
            className: [classes.menuListItem, isHighlighted || item.label === value || item.value === value ? "active" : ""].join(" ")
          }, _react2.default.createElement('div', {
            className: classes.menuListItemText
          }, text));
        }
      }, other)));
    }
  }]);

  return Autocomplete;
}(_react.Component), _class.contextType = _context2.default, _class.propTypes = {
  classes: _propTypes2.default.object.isRequired,
  items: _propTypes2.default.array.isRequired,
  value: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  onDelete: _propTypes2.default.func,
  viewHandler: _propTypes2.default.func,
  viewElement: _propTypes2.default.object,
  addHandler: _propTypes2.default.func,
  saveHandler: _propTypes2.default.func,
  getItemText: _propTypes2.default.func.isRequired
}, _class.defaultProps = {
  items: [],
  value: "",
  fullWidth: true,
  getItemText: function getItemText(item) {
    var value = item.value,
        label = item.label;
    return label;
  }
}, _temp2);
exports.default = (0, _styles.withStyles)(styles)(function (props) {
  return _react2.default.createElement(Autocomplete, props);
});